import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function orderList(state = {}, action) {
    switch (action.type) {
        //action.filter
        //action.status
        //action.error

        case types.SET_GLOBAL_ERRORS:
            return {
                ...state,
                [action.filter]: {error: action.error, status: action.status}
            }


        case types.CLEAR_GLOBAL_ERRORS:
            return {}

    
        default:
            return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/globalErrorReducer.js